export default `제1조 (목적)

이 약관은 사단법인 한국프로스포츠홀덤연맹(이하 "연맹")과 프로 자격을 취득하려는 자(이하 "응시자") 간에 이루어지는 홀덤 프로 자격 취득을 위한 자격검정(이하 “시험”)에 관련된 응시 절차, 평가 방식, 권리·의무 및 기타 제반 사항을 규정함을 목적으로 합니다.

제2조 (용어의 정의)

이 약관에서 사용하는 용어의 정의는 다음과 같습니다.

1. “프로”란 사단법인 한국프로스포츠홀덤연맹(이하 “연맹”)이 신설하여 관리 및 운영하는 자격을 말합니다.
2. “프로”는 통칭으로, “루키”, “세미”, “투어” 3등급으로 구성되며, 연맹의 정책에 따라 등급의 명칭 변경 또는 추가가 이루어질 수 있습니다.
3. “연맹”이란 「민법」 제32조 및 「문화체육관광부 및 국가유산청 소관 비영리법인의 설립 및 감독에 관한 규칙」 제4조에 따라 설립된 비영리 법인을 말합니다.
4. “응시자”란 프로 자격을 취득하기 위해 연맹 또는 대행사가 시행하는 자격검정시험에 응시하는 자를 말합니다.
5. “대행사”란 연맹과의 위탁계약을 통해 응시자를 대상으로 자격검정시험을 기획·운영하는 기관으로, 본 약관에서는 “주식회사 프리플랍”을 의미합니다.
6. “플랫폼”이란 대행사가 연맹을 대신하여 응시자에게 자격검정시험을 제공하는 디지털 기반의 온라인 서비스 환경을 말합니다.
7. “필기 시험”이란 프로 자격 취득을 위한 1차 평가 절차로, 대행사의 플랫폼을 통해 온라인으로 시행되는 시험을 말합니다.
8. “트라이아웃(이하 ‘실기 시험’)”이란 필기 시험 합격자를 대상으로 실시되는 2차 평가 절차로, 오프라인 환경에서 실기 방식으로 진행됩니다.

이 약관에 규정되지 아니한 사항에 대해서는 「약관의 규제에 관한 법률」, 전자상거래 등에서의 소비자보호에 관한 법률」, 「민법」등 관계법령에 따릅니다. 또한 관계법령 내 강행규정에 반하지 않는 한, 연맹과 프로 자격을 취득하려는 자가 개별적으로 약정한 바에 따릅니다.

제3조 (시험 응시 자격 및 절차)

1. 응시 자격
다음 각 호에 해당하는 자는 프로 자격 검정시험에 응시할 수 있습니다.
    1.1. 만 19세 이상의 성인으로 대한민국 국민 또는 국내 거주 외국인
    1.2. 관련 법령에 따라 자격 취득에 결격 사유가 없는 자
    1.3. 연맹 또는 대행사가 정한 응시 신청 절차를 완료한 자
2. 응시 절차
프로 자격 검정시험은 다음과 같은 절차에 따라 진행됩니다.
    2.1. 응시자는 대행사의 플랫폼을 통해 응시 신청서를 작성하고 소정의 응시료를 납부하여야 합니다.
    2.2. 대행사는 응시자의 자격 요건 및 신청 내용 확인 후 접수 완료 여부를 통지합니다.
    2.3. 접수 완료 후 응시자는 정해진 절차에 따라 필기 시험에 응시하게 됩니다.
    2.4. 필기 시험 합격자는 오프라인으로 진행되는 트라이아웃(실기 시험)에 참여할 수 있는 자격이 부여됩니다.
3. 응시 제한 및 불인정
다음 각 호에 해당하는 경우, 연맹 또는 대행사는 응시 자격을 제한하거나 응시 결과를 무효화할 수 있습니다.
    3.1. 타인의 명의 또는 허위 정보를 사용하여 신청한 경우
    3.2. 과거 부정행위로 인해 자격 제한 또는 취소 처분을 받은 경우
    3.3. 시험 과정에서 부정행위 또는 품위 손상 행위가 확인된 경우
    3.4. 기타 연맹 또는 대행사가 정한 기준에 부합하지 않는 경우

제4조 (응시자의 의무)

1. 응시자는 다음 각 호의 사항을 성실히 준수하여야 합니다.
    1.1. 본 약관 및 연맹·대행사가 정한 시험 운영 규정 및 지침
    1.2. 시험 신청 및 진행 과정에서 허위 정보를 기재하지 않을 의무
    1.3. 본인의 명의로만 응시하며, 타인의 명의를 도용하거나 대리 응시하지 않을 의무
    1.4. 시험 중 부정행위(통신기기 사용, 타 응시자와의 접촉 등)를 하지 않을 의무
    1.5. 시험 과정에서 연맹 또는 대행사의 정당한 지시 및 안내에 협조할 의무
2. 응시자는 시험 중 또는 관련 행사에서 다음과 같은 행위를 하여서는 안 됩니다.
    2.1. 시험 문제 또는 운영 자료를 무단으로 복사, 촬영, 유출하는 행위
    2.2. 사회적 물의를 일으키는 언행, 비방, 폭언, 폭행, 음주, 도박 등의 행위
    2.3. 시험장의 질서 유지나 타 응시자의 시험 응시에 방해가 되는 행위
    2.4. 연맹 또는 대행사의 명예를 훼손하거나 업무를 방해하는 행위
    2.5. 기타 관련 법령 및 공공질서에 위반되는 행위
3. 응시자가 본 조의 의무를 위반한 경우, 연맹 또는 대행사는 시험 응시 취소, 자격 부여 거부, 향후 응시 제한 등의 조치를 취할 수 있습니다.

제5조 (부정행위자에 대한 조치)

1. 연맹 또는 대행사는 시험 과정 중 또는 시험 이후 아래 각 호의 부정행위가 확인된 응시자에 대해 해당 시험의 무효 처리 및 향후 응시 자격 제한 등의 조치를 취할 수 있습니다.
    1.1. 타인의 명의를 사용하거나 대리 응시를 한 경우
    1.2. 시험 중 문제지를 무단 촬영, 복사, 유출하거나, 타 응시자와 의사소통을 시도한 경우
    1.3. 시험 운영진의 지시를 고의로 거부하거나 방해한 경우
    1.4. 금지된 물품(전자기기, 메모지 등)을 소지 또는 사용한 경우
    1.5. 기타 공정한 시험 운영을 심각하게 저해한 경우
2. 부정행위가 적발된 경우, 연맹은 다음과 같은 조치를 취할 수 있습니다.
    2.1. 해당 시험의 무효 및 불합격 처리
    2.2. 자격 부여의 취소(이미 자격을 부여받은 경우)
    2.3. 최대 3년간 응시 제한 또는 영구 응시 금지
    2.4. 필요 시 민·형사상의 법적 조치
3. 응시자는 부정행위 관련 조치에 대해 7일 이내에 소명자료와 함께 이의신청을 제출할 수 있으며, 연맹은 내부 심사를 통해 최종 결정을 내립니다.
4. 부정행위가 조직적이거나 반복적으로 발생한 경우, 연맹은 해당 사실을 대외적으로 공지할 수 있으며, 관련 기관에 통보할 수 있습니다.

제6조 (시험 결과 통지 및 자격 부여)

1. 시험 결과는 필기 및 실기 시험 종료 후 14일 이내에 플랫폼을 통해 공지되며, 필요 시 개별 통지가 병행될 수 있습니다.
2. 최종 합격자는 연맹이 정한 기준을 충족한 자에 한하며, “루키”, “세미”, “투어” 중 해당 등급의 프로 자격이 부여됩니다.
3. 합격자는 연맹 또는 대행사가 정한 절차에 따라 자격 등록을 완료해야 하며, 자격증 발급 및 등재가 이루어집니다.
4. 합격자의 이름, 등급, 자격 번호 등은 연맹의 공식 명단 및 공공 채널에 게시될 수 있습니다.
5. 불합격자에게는 별도의 자격이 부여되지 않으며, 재응시는 연맹이 정한 기준에 따릅니다.

제7조 (이의 신청 절차)

1. 응시자는 시험 결과에 이의가 있을 경우, 결과 발표일로부터 7일 이내에 서면(또는 이메일)을 통해 이의 신청서를 제출할 수 있습니다.
2. 이의 신청서에는 신청인의 성명, 연락처, 응시 번호, 이의 내용, 관련 근거 자료 등을 명확히 기재하여야 합니다.
3. 연맹은 이의 신청 접수 후 10일 이내에 심사위원회를 구성하여 심사하고, 그 결과를 응시자에게 통지합니다.
4. 이의 신청 결과에 따라 필요 시 시험 결과가 수정될 수 있으며, 연맹의 최종 결정은 재심사 없이 확정됩니다.
5. 이의 신청 절차 중에도 연맹의 자격 부여 또는 취소 권한은 유지되며, 응시자는 이에 협조해야 합니다.

제8조 (응시료의 환불)

1. 필기 시험의 경우 응시료 납부 후 즉시 온라인 시험이 시작 됨으로 어떠한 경우에도 필기 시험 응시료를 환불 받을 수 없습니다.
2. 실기 시험의 경우 한 번 사용된 응시 티켓은 어떠한 경우에도 환불 받을 수 없습니다.
3. 다음 각 호의 경우, 응시자는 응시료의 일부 또는 전액 환불을 요청할 수 없습니다.
    3.1. 필기 시험 접수 마감일 이후 응시자가 임의로 취소하거나 결시한 경우
    3.2. 응시자의 귀책사유로 인해 응시 자격이 박탈된 경우
    3.3. 부정행위 등으로 시험 무효 처리된 경우
4. 불가피한 사정(예: 천재지변, 입원 등)으로 인해 응시하지 못하는 경우, 관련 증빙서류 제출 시 연맹 또는 대행사의 판단에 따라 응시료의 일부 또는 전액을 환불할 수 있습니다.
5. 환불 요청은 플랫폼 또는 고객센터를 통해 가능하며, 환불 결정 후 영업일 기준 7일 이내에 지정 계좌로 입금됩니다.
6. 연맹 또는 대행사의 귀책사유로 시험이 취소된 경우, 응시자에게 전액 환불하며 별도 요청 없이 자동 환불 처리됩니다.

제9조 (연맹의 의무)

1. 연맹은 응시자가 공정하고 안전하게 시험에 응시할 수 있도록 시험 운영 전반에 대해 최선의 노력을 다하여야 합니다.
2. 연맹은 시험 시행과 관련한 일정, 절차, 기준 등을 사전에 명확히 공지하고, 응시자가 이를 충분히 인지할 수 있도록 조치하여야 합니다.
3. 연맹은 시험 문제 출제, 채점, 자격 부여 등의 과정에서 객관성과 공정성을 유지하며, 임의적 판단 또는 차별을 배제합니다.
4. 연맹은 응시자의 개인정보 및 시험 응시와 관련한 민감 정보를 「개인정보 보호법」 등 관계 법령에 따라 보호하며, 정당한 사유 없이 제3자에게 제공하지 않습니다.
5. 연맹은 응시자의 정당한 이의 제기에 대해 성실하고 신속하게 응답하여야 하며, 이의 심사 및 처리 결과를 투명하게 고지합니다.
6. 연맹은 시험 운영과 관련하여 응시자에게 불이익이 발생하지 않도록 관리·감독 책임을 이행하고, 대행사가 이를 위반하지 않도록 협력 체계를 유지합니다.

제10조 (플랫폼의 의무)

1. 플랫폼 운영자는 연맹과의 위탁계약에 따라 시험의 신청, 접수, 필기시험 진행 등 제반 업무를 성실히 수행할 의무가 있습니다.
2. 플랫폼은 시험 응시자에게 안정적이고 접근성 높은 온라인 환경을 제공하여, 기술적 오류나 접속 장애로 인해 응시가 방해되지 않도록 하여야 합니다.
3. 플랫폼은 응시자의 개인정보, 시험 응답 내용, 결과 등 민감 정보를 「개인정보 보호법」에 따라 안전하게 관리하며, 외부 유출을 방지하기 위한 보안 시스템을 유지해야 합니다.
4. 플랫폼은 연맹이 정한 시험 규정과 기준을 충실히 이행하며, 시험 운영 중 발생한 민원 및 기술적 문의에 대해 신속하게 응대해야 합니다.
5. 플랫폼은 시스템 오류, 보안 침해, 장애 등으로 인해 시험이 정상적으로 진행되지 못한 경우, 즉시 해당 사실을 응시자 및 연맹에 고지하고 복구 조치를 취해야 합니다.
6. 플랫폼은 응시자에 대한 고지 사항(시험 일정, 접수 확인, 결과 발표 등)을 정확하고 명확하게 전달할 책임이 있으며, 누락 또는 오류로 인한 불이익이 없도록 해야 합니다.

제11조 (자격의 효력 및 취소)

1. 프로 자격의 효력은 연맹이 정한 절차에 따라 합격자 명단을 확정하고, 자격 등재 및 발급이 완료된 시점부터 발생합니다.
2. 부여된 자격은 연맹이 정한 기준에 따라 등급별로 분류되며, 자격 보유자는 해당 등급의 권한과 활동 자격을 부여받습니다.
3. 다음 각 호의 경우, 연맹은 부여된 자격을 직권으로 취소하거나 자격 정지 조치를 취할 수 있습니다.
    3.1. 응시 또는 자격 취득 과정에서 부정행위 또는 허위 사실이 발견된 경우
    3.2. 연맹 또는 대행사의 명예를 훼손하거나 중대한 불법 행위를 저지른 경우
    3.3. 자격 유지에 필요한 연맹 규정을 반복적으로 위반한 경우
    3.4. 기타 자격 유지가 부적절하다고 판단되는 중대한 사유가 있는 경우
4. 자격 취소 또는 정지 조치가 이루어진 경우, 연맹은 대상자에게 사전 통지 및 의견 제출 기회를 제공하며, 최종 처분 결과는 개별 통보합니다.
5. 자격이 취소된 경우, 해당 자격은 즉시 효력을 상실하며, 자격증은 무효 처리됩니다. 또한 자격에 따라 부여되었던 모든 권한은 박탈됩니다.

제12조 (면책 조항)

1. 연맹 및 플랫폼은 다음 각 호에 해당하는 사유로 인해 응시자에게 발생한 손해에 대하여 책임을 지지 않습니다.
    1.1. 천재지변, 전쟁, 법령의 제·개정, 정부의 행정처분 등 불가항력적인 사유
    1.2. 응시자의 고의 또는 과실로 인한 접속 장애, 정보 오기재, 시험 미응시
    1.3. 정당한 사전 고지에 따른 시험 일정 변경, 운영 방식의 조정
    1.4. 응시자의 시스템 환경(인터넷, 디바이스, 브라우저 설정 등) 문제로 인한 응시 불능
    1.5. 연맹 또는 플랫폼이 직접적으로 통제할 수 없는 외부 서비스 장애
2. 연맹 및 플랫폼은 응시자가 시험 중 제공한 정보나 답변 내용의 신뢰성 및 정확성에 대해 보증하지 않으며, 해당 내용은 응시자의 책임 하에 작성된 것으로 간주됩니다.
3. 연맹 및 플랫폼은 응시자가 본 약관 및 시험 운영 지침을 위반함으로써 발생한 결과에 대해서는 책임을 지지 않습니다.

13조 (초상권 및 시험 결과의 활용)

1. 연맹 및 대행사(플랫폼)는 트라이아웃 시험 진행 과정에서 촬영된 영상, 사진, 응시자의 성명, 성적 등 결과 정보를 다음 각 호의 범위 내에서 사용할 수 있습니다.
    1.1. 시험의 공정성과 투명성 확보를 위한 내부 기록 및 검토
    1.2. 프로 자격 홍보 및 연맹 공식 콘텐츠(예: 유튜브, 홈페이지, 보도자료 등)에 활용
    1.3. 응시자의 프로 자격 부여, 등급 분류 및 등록 명단 작성
    1.4. 기타 연맹 및 대행사가 사전에 고지한 범위 내에서의 공익적 목적
2. 응시자는 시험 응시에 따라 자신의 초상(사진, 영상), 성명, 수험번호, 점수 등이 연맹 및 대행사의 홍보, 기록, 인증 목적 등에 활용될 수 있음에 동의한 것으로 간주합니다.
3. 연맹 및 대행사는 사용 목적과 관계없이 응시자의 인격권을 침해하지 않으며, 외부 공개 시 필요에 따라 익명처리 또는 모자이크 등의 조치를 취할 수 있습니다.
4. 응시자는 본 조와 관련한 활용을 원하지 않을 경우, 사전 또는 시험 직후 서면(전자 포함)으로 거부 의사를 명시해야 하며, 이 경우 연맹은 해당 자료의 활용을 제한합니다.

제14조 (준거법 및 분쟁 해결)

1. 이 약관은 대한민국 법령에 따라 해석되며, 응시와 관련된 연맹, 대행사, 응시자 간의 모든 법적 분쟁은 대한민국 법률을 준거법으로 합니다.
2. 이 약관 또는 시험 운영과 관련하여 연맹, 대행사, 응시자 간에 분쟁이 발생할 경우, 당사자들은 원만한 해결을 위해 성실히 협의하여야 합니다.
3. 협의에 의해 분쟁이 해결되지 아니하는 경우, 민사소송법에 따라 연맹의 주된 사무소 소재지를 관할하는 서울중앙지방법원을 제1심 전속 관할 법원으로 합니다.

부칙

1. 본 약관은 2025년 5월 2일부터 시행합니다.
2. 본 약관 시행 이전에 응시 중인 자에 대해서도 본 약관이 동일하게 적용됩니다.
3. 연맹 또는 대행사는 필요 시 본 약관에 대한 세부 시행 규칙을 별도로 제정할 수 있으며, 이 경우 관련 내용을 응시자에게 고지합니다.

`